export default __webpack_public_path__ + "static/post1-4b2753925cedae94b991015159f0c509.jpg";